// extracted by mini-css-extract-plugin
export default {"tabIconContainer":"src-signer-app-signature-modal-common-tab-icon-container-module__tabIconContainer--1w3NJ"};